module.exports = __webpack_public_path__ + "static/media/dmx-tab-lg-md.0197d7e3.svg";